import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import {BrowserRouter} from "react-router-dom";
import Recovery from "./Pages/Vets/Recovery";
import * as Sentry from "@sentry/react";

Sentry.init({
	dsn: "https://4d3577befbea46cf94737b5ff6426e61@o4504942051852288.ingest.sentry.io/4504942214184960",
	integrations: [new Sentry.BrowserTracing()],
	tracesSampleRate: (process.env.NODE_ENV === 'production') ? 0.25 : 1.0,
	environment: process.env.NODE_ENV,
});

if(process.env.NODE_ENV !== "development") {
	console.log = () => {};
}

const l = window.location.pathname;
if (l.includes('/recovery/')) {
	ReactDOM.render(
		<React.StrictMode>
			<Recovery/>
		</React.StrictMode>,
		document.getElementById('root')
	);
} else {
	ReactDOM.render(
		<BrowserRouter>
			<App/>
		</BrowserRouter>,
		document.getElementById('root')
	);
}

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();